<template>
  <div :class="props.class || ''">
    <div v-if="props.tags" class="block">
      <div v-for="(tag, index) in tags" :key="index">
        <div
          v-if="tag"
          :style="{ background: tag.color || '#FFFFFF' }"
          class="block float-left uppercase font-bold text-xs text-primary-white px-1"
        >
          <span :style="{ color: getContrastYIQ(tag.color || '#FFFFFF') }">
            {{ locale === 'en' ? tag.en : tag.th || tag.en }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { locale } = useI18n()
const props = defineProps<{
  class?: string
  isLoading?: boolean
  tags?: { th?: string; en: string; color?: string }[]
}>()
</script>
